<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="hypersoft-bonus.svg"></div>
    </div>
    <h2 langkey="phBenefit_Redeem_Dialog_Title"></h2>
    <div class="redeem-content--atThePlace">
      <span langkey="phBenefit_Redeem_Dialog_InStore_Desc"></span>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-container">
        <button a11y_Button mat-flat-button (click)="redeemInStore()">
          <span langkey="phBenefit_Redeem_Dialog_InStore_Btn"></span>
        </button>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="redeem-content--shop">
      <span langkey="phBenefit_Redeem_Dialog_Online_Desc"></span>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-container">
        <button a11y_Button mat-flat-button (click)="redeemOnline()">
          <span langkey="phBenefit_Redeem_Dialog_Online_Btn"></span>
        </button>
      </div>
    </div>
  </div>
</div>